module.exports = __webpack_public_path__ + "static/media/[Lectures_and_Panels]2013-12-08.40a6265a.md";